module.exports = __webpack_public_path__ + "images/errorAtAddingPartner_1665e64.svg";